module.exports = __webpack_public_path__ + "static/media/Akemi_5841.f2a67a67.jpg";